import { formatDate, formatDateTime } from '@/lib/formatDate';
import type { ContextAuthor, PatientAgentContext } from '../../models/patientAgentContext';

const ROLE_LABELS: Record<string, string> = {
  admin: 'admin',
  doctor: 'doctor',
  nutritionist: 'nutricionista',
};

export const roleLabel = (role: string) => ROLE_LABELS[role] ?? role;

export function authorName(author: ContextAuthor | null): string {
  return author?.name?.trim() || 'una persona que ya no está en la clínica';
}

// "Versión 7 · actualizado el 20 oct 2026 por Dra. Ruiz"
export function contextMeta(c: PatientAgentContext): string {
  const parts = [`Versión ${c.version}`];
  if (c.updatedAt) parts.push(`actualizado el ${formatDate(c.updatedAt)} por ${authorName(c.updatedBy)}`);
  return parts.join(' · ');
}

export const revisionWhen = (iso: string) => formatDateTime(iso);

// The note text to append when a note is used as context.
export function appendToContext(current: string, addition: string): string {
  const base = current.replace(/\s+$/, '');
  const extra = addition.trim();
  if (!extra) return current;
  return base ? `${base}\n${extra}` : extra;
}
